import { Icon } from "@iconify/react/dist/iconify.js";

const Page404 = () => {
  return (
    <div className="content-404">
      <div className="showdetail-404">
        <div className="boxdetail-show">
          <div>
            <Icon
              icon="fluent:emoji-sad-16-regular"
              height={"40%"}
              width={"40%"}
            />
          </div>
          <div>
            <span>page not found !!!</span>
          </div>
        </div>
        <div></div>
      </div>
    </div>
  );
};
export default Page404;
